export const PALETTE_GROUPS = [
  {
    key: "composite",
    title: "Composite",
    items: [
      {
        key: "sequence",
        label: "Sequence",
        help: "Runs each child step in order. Stops if one fails.",
      },
      {
        key: "selector",
        label: "Fallback",
        help: "Tries each child in order until one succeeds.",
      },
      {
        key: "ifThenElse",
        label: "If / Then / Else",
        help: "Condition branch with fixed slots: condition, then, and optional else.",
      },
      {
        key: "retry",
        label: "Retry",
        help: "Re-runs its child if it fails, up to a set number of attempts.",
      },
      {
        key: "repeat",
        label: "Repeat",
        help: "Runs its child a set number of times.",
      },
    ],
  },
  {
    key: "templates",
    title: "Templates",
    items: [
      {
        key: "templateIfThenElse",
        label: "If … then / else",
        help: "Inserts Fallback + Sequence + Condition starter pattern as a teaching template.",
      },
    ],
  },
  {
    key: "motion",
    title: "Motion",
    items: [
      {
        key: "servoPickPlace",
        label: "Pick & place servo",
        help: "Automated grasp-and-place using smooth, guided motion.",
      },
      {
        key: "moveEeToXyz",
        label: "Move EE → XYZ",
        help: "Moves the robot's hand to a specific point in space.",
      },
      {
        key: "moveEeByOffset",
        label: "Move EE Δ",
        help: "Nudges the robot's hand by a small offset from where it is now.",
      },
      {
        key: "goToKeyframe",
        label: "Go to keyframe",
        help: "Moves the robot to a saved pose.",
      },
    ],
  },
  {
    key: "gripper",
    title: "Gripper",
    items: [
      { key: "openGripper", label: "Open", help: "Opens the gripper to release an object." },
      { key: "closeGripper", label: "Close", help: "Closes the gripper to grasp an object." },
    ],
  },
  {
    key: "scene",
    title: "Scene",
    items: [
      {
        key: "randomizeObjectPose",
        label: "Randomize object",
        help: "Places the target object at a random position for variety.",
      },
      {
        key: "setObjectPose",
        label: "Set object pose",
        help: "Moves an object to a specific position and orientation.",
      },
      {
        key: "resetToBaseline",
        label: "Reset baseline",
        help: "Restores the scene to its saved starting state.",
      },
      {
        key: "wait",
        label: "Wait",
        help: "Pauses for a set amount of time before continuing.",
      },
    ],
  },
  {
    key: "episode",
    title: "Episode",
    items: [
      {
        key: "markSuccess",
        label: "Mark success",
        help: "Ends the current run as a success.",
      },
      {
        key: "markFailure",
        label: "Mark failure",
        help: "Ends the current run as a failure.",
      },
    ],
  },
  {
    key: "conditions",
    title: "Conditions",
    items: [
      {
        key: "conditionObjectGrasped",
        label: "Object lifted",
        help: "Checks whether the object is currently grasped and off the ground.",
      },
      {
        key: "conditionEeNear",
        label: "EE near point",
        help: "Checks whether the robot's hand is close to a target point.",
      },
      {
        key: "conditionObjectNear",
        label: "Object near point",
        help: "Checks whether an object is close to a target point.",
      },
      {
        key: "conditionTimeElapsed",
        label: "Time elapsed",
        help: "Checks whether a set amount of time has passed.",
      },
    ],
  },
];
